import instance from './instance'

const dashboardUrl = 'modules-lead/dashboard'

export const getDashboardList = () =>
    instance.get(`${dashboardUrl}`)

export const getDashboardById = (id: number) => instance.get(`${dashboardUrl}/${id}`)
  

  